import React, { useState } from "react";
import { Input, InputProps } from "@/components/ui/input";
import { v4 as uuid } from "uuid";
import { cn } from "@/lib/utils";
interface InputWrapperProps extends InputProps {
  labelText?: string;
  isElementValid?: boolean;
  isElementTouched?: boolean;
}
const InputWrapper = React.forwardRef<HTMLInputElement, InputWrapperProps>(({
  labelText,
  isElementValid,
  isElementTouched,
  disabled,
  ...props
}, ref) => {
  const [value, setValue] = useState(props.value || "");
  const inputId = props.id || uuid();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return <>
        <Input {...props} value={value} onChange={handleChange} id={inputId} ref={ref} peer title={labelText} disabled={disabled} className={`${isElementValid && !disabled ? "border-green-500" : isElementTouched ? "border-red-500" : ""} ${props.className}`}>
          {!!labelText && <label htmlFor={inputId} title={labelText} className={cn("pointer-events-none absolute left-1 top-2 z-10 !mt-0 w-auto origin-[0] -translate-y-4 scale-75 select-none overflow-hidden overflow-ellipsis rounded-3xl bg-background px-2 text-sm text-foreground/80 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:whitespace-nowrap peer-focus:px-2 peer-focus:font-semibold peer-focus:text-glow", isElementValid && !disabled ? "whitespace-nowrap text-green-500" : "")}>
              {labelText}
            </label>}
        </Input>
      </>;
});
InputWrapper.displayName = "InputWrapper";
export default InputWrapper;